import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'antd';
import { injectIntl } from 'react-intl';
import { useHistory, generatePath } from 'react-router-dom';
import { ROUTE_PACIENTES_EYECHART_NEW } from '../../../../routes.constants';

interface ModalContentProps{
  src: string,
  alt: string,
  name: string,
  onClick?: Function,
}

interface ModalTestsProps{
  modalState: any,
  closeModal: any,
  pacienteSelected: any,
  intl: any
}

function ModalTests({
  modalState, closeModal, pacienteSelected, intl,
}: ModalTestsProps) {
  const history = useHistory();
  const [content, setContent] = useState<ModalContentProps[]>([]);

  const headerModal = (
    <div>
      <div className="ant-modal-title">
        {intl.formatMessage({ id: 'pacientes.client_file.tests' })}
      </div>
      <div className="modal-subtitle">{pacienteSelected?.nombre_completo}</div>
    </div>
  );

  useEffect(() => {
    if (pacienteSelected !== null) {
      setContent([
        {
          src: '/img/pacientes/Optometria.svg',
          alt: 'Optometría',
          name: intl.formatMessage({ id: 'pacientes.client_file.optometry' }),
          onClick() { history.push(generatePath(ROUTE_PACIENTES_EYECHART_NEW, { pacienteId: pacienteSelected.id })); },
        },
        {
          src: '/img/pacientes/Contactologia.svg',
          alt: 'Contactología',
          name: intl.formatMessage({ id: 'pacientes.client_file.contactology' }),
        },
        {
          src: '/img/pacientes/Audiometria.svg',
          alt: 'Audiometría',
          name: intl.formatMessage({ id: 'pacientes.client_file.audiometry' }),
        },
        {
          src: '/img/pacientes/ScreeningAuditivo.svg',
          alt: 'Screening_Auditivo',
          name: intl.formatMessage({ id: 'pacientes.client_file.hearing_screening' }),
        },
      ]);
    }
  }, [pacienteSelected]);

  return (
    <>
      <Modal
        title={headerModal}
        visible={modalState}
        onCancel={closeModal}
        footer={[
          <Button key="back" onClick={closeModal}>
            {intl.formatMessage({ id: 'generico.cancelar' })}
          </Button>,
        ]}
        width={656}
        className="modalNewTest"
      >
        <div className="modalContent">
          {content.map((element:any) => (
            <div
              key={element.alt}
              className="modalOptions"
              onClick={() => {
                if (element?.onClick) element.onClick();
              }}
            >
              <h3 className="tests">{element.name}</h3>
              <div className="testImg">
                <img src={element.src} alt={element.alt} />
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
}

export default injectIntl(ModalTests);
